import { useState, useEffect } from 'react';
import './navWeb.css'
import { Link, useLocation } from 'react-router-dom';

export default function NavWeb(){
    const location=useLocation()

    const [navBG, setNavBG] = useState('none')
    const [boxShadow, setBoxShadow] = useState('none')
    const handleScroll = () => {
        const position = window.scrollY;
        if (position >= 100) {
            setNavBG('#161616') 
            setBoxShadow('rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px')
        } else {
            setNavBG('none')
            setBoxShadow('none') 
        }
      };
      useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const [navbar, setNavbar] = useState(<NavWeb/>)
    const navSelect = () =>{
        if(window.window<768){
            setNavbar()
        }
    }
    return(
        <div className='nav_container' style={{background:navBG, boxShadow:boxShadow}}>
            <nav>
            <div className='nav_main'>
                <div className='nav_logo'>
                {
                    location.pathname==="/"?
                        <a href='#home'>
                            <img src='./images/LogoDark.svg' alt='trulle'/>
                        </a>:
                        <Link to='/'>
                            <img src='./images/LogoDark.svg' alt='trulle'/>
                        </Link>
                }
                    
                </div>
                <div className='nav_web_menu align_right'>
                    {location.pathname==="/"?<a href='#home'>Home</a>:<Link to='/'>Home</Link>}
                    <a href='#about'>About Us</a>
                    <a href='#service'>Service</a>
                    <a href='#portfolio'>Portfolio</a>
                    <Link to='/contact'>Contact Us</Link>
                </div>
                <div className='nav_what'>
                    <a href='http://wa.me/917826099040'>
                        <img src='./images/call.svg' alt='trulle'/>
                    </a>
                </div>
            </div>
            </nav>
        </div>
    );
}